import CloseButtonModal from '../../../ui/close-button-modal';

interface Props {
    handleCloseModal: () => void;
    errorMessage: string;
}

export default function ErrorProfileModal({ handleCloseModal, errorMessage }: Props) {
    return (
        <div className='fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-4'>
            <div className='relative bg-white rounded shadow w-full sm:w-96 md:w-[80%] lg:w-[65%] max-h-[90vh] min-h-[400px] overflow-y-hidden p-6'>
                <div className={`space-y-4`}>
                    <div className="flex justify-between items-center py-1">
                        <div className="items-start">
                            <p className="text-base items-start font-semibold leading-tight text-slate-900">
                                {'Error'}
                            </p>
                        </div>
                        <div className="flex justify-end items-center">
                            <CloseButtonModal handleClose={handleCloseModal}/>
                        </div>
                    </div>
                    <hr className="h-px bg-gray-200 border-0" />
                    <div className='flex items-center text-center justify-center'>
                        <p className='text-black text-sm'>{errorMessage || 'Failed to load user data.'}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
